import React from 'react';
import styles from './ButtonGroup.module.scss';

const ButtonGroup: React.FunctionComponent = ({ children }) => {
  return <div className={styles.component}>{children}</div>;
};

export default ButtonGroup;
